"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ServerSideEncryptionConfiguration_1 = require("./_ServerSideEncryptionConfiguration");
exports.GetBucketEncryptionOutput = {
    type: "structure",
    required: [],
    members: {
        ServerSideEncryptionConfiguration: {
            shape: _ServerSideEncryptionConfiguration_1._ServerSideEncryptionConfiguration
        }
    },
    payload: "ServerSideEncryptionConfiguration"
};
//# sourceMappingURL=GetBucketEncryptionOutput.js.map